import {z} from "zod";

const schema = z.object({
	token: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeAuthenticationResModel = {schema, model};
export type IEmployeeAuthenticationResModel = z.infer<typeof EmployeeAuthenticationResModel.model>;
export const DEFAULT_EMPLOYEE_AUTHENTICATION: IEmployeeAuthenticationResModel = {
	token: ""
};
